import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from 'src/theme';
const useCommonStyles = makeStyles((theme: Theme) => {
  return createStyles({
    displayCode: {
      padding: '7px',
      borderRadius: '5px',
      fontWeight: 'bold',
      fontSize: 'Larger',
      color: 'grey',
    },
    displayCodeColorYellow: {
      background: '#fffbb9',
      border: '1px solid #ffe02f',
    },
    displayCodeColorGreen: {
      background: '	#b7fab7',
      border: '1px solid 	#48d148',
    },
    copyIcon: { marginLeft: 4, cursor: 'pointer' },
    displayCodeContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  });
});

export default useCommonStyles;